import { useAtom, useAtomValue } from 'jotai';
import { useRelayEnvironment } from 'react-relay';
import { fetchQuery } from 'relay-runtime';

import { paymentCardsQuery } from '@/graphql/query/paymentCard/paymentCards';
import { CARD_LOGO } from '@/lib/constants/card';
import { paymentCardDataAtom, paymentCardLoadingAtom, hasRegisteredCardAtom, firstCardAtom, cardNameAtom, cardNumberAtom } from '@/lib/stores/payment-card';

export const usePaymentCard = () => {
  const [cardData, setCardData] = useAtom(paymentCardDataAtom);
  const [loading, setLoading] = useAtom(paymentCardLoadingAtom);

  const hasRegisteredCard = useAtomValue(hasRegisteredCardAtom);
  const firstCard = useAtomValue(firstCardAtom);
  const cardName = useAtomValue(cardNameAtom);
  const cardNumber = useAtomValue(cardNumberAtom);

  const relayEnvironment = useRelayEnvironment();

  const fetchCardData = async () => {
    if (cardData) {
      return cardData;
    }

    try {
      setLoading(true);

      const data = (await fetchQuery(relayEnvironment, paymentCardsQuery, {}).toPromise()) as any;

      setCardData(data?.paymentCards || null);
      return data?.paymentCards || null;
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const refreshCardData = async () => {
    setCardData(null);
    return fetchCardData();
  };

  const cardLogo = firstCard?.cardCd ? (CARD_LOGO[firstCard.cardCd] ?? '') : '';

  return {
    cardData,
    hasRegisteredCard,
    firstCard,
    cardName,
    cardNumber,
    cardLogo,
    loading,
    setCardData,
    fetchCardData,
    refreshCardData
  };
};
